(function() { window.GUID_d127feb7_dd87_419b_8c35_b5fb3fa3a85d = { getGuid: function() { return "d127feb7-dd87-419b-8c35-b5fb3fa3a85d"; } }; })();
var CS;
(function (CS) {
    class CalendarPicker extends CS.Calendar {
        constructor(inputBox) {
            super(inputBox, true);
        }
    }
    CS.CalendarPicker = CalendarPicker;
})(CS || (CS = {}));
//(function ($) {
//    $.fn.CSCalendarPicker = function () {
//        this.each(function () {
//            var datePicker = new CS.CalendarPicker($(this));
//            //Donne access au datepicker de n'importe quels scripts.
//            eval('document.' + datePicker.DatePickerId + '=datePicker;');
//        });
//    };
//})(jQuery);
//var CS = CS || {};
//CS.CalendarPicker = function (inputBox: JQuery) {
//    var me = this;
//    me.InputBox = inputBox;
//    me.InputBox.data('context', me);
//    me.SelectionChange = null;
//    me.val = function (newVal) {
//        if (newVal != null) {
//            inputBox.datepicker('setDate', newVal);
//            inputBox.trigger('change');
//        }
//        else {
//            return me.InputBox.val();
//        }
//    };
//    me.DatePickerId = inputBox[0].id;
//    this.CSDatePicker = inputBox.datepicker({
//        changeMonth: true,
//        changeYear: true,
//        numberOfMonths: 1,
//        beforeShowDay: function (d) {
//            //ScheduleDates vient de la des vues qui applique JSArrayHelper 
//            if (typeof ScheduledDates !== 'undefined' && ScheduledDates != null) {
//                var year = d.getFullYear();
//                var month = d.getMonth() + 1;
//                var day = d.getDate();
//                if (month.toString().length == 1) {
//                    month = '0' + month;
//                }
//                if (day.toString().length == 1) {
//                    day = '0' + day;
//                }
//                var result = year + '-' + month + '-' + day;
//                if ($.inArray(result, ScheduledDates) != -1) {
//                    //[0] = true/false (isEnable or not                //[1] = CSS class                //[2] = tooltip
//                    return [true, "HighlightedDayDatePicker", "Available"];
//                }
//                else {
//                    return [true, "NotHighlightedDayDatePicker", "unAvailable"];
//                }
//            }
//            else {
//                return [true, "NotHighlightedDayDatePicker", "unAvailable"];
//            }
//        },
//        showButtonPanel: false
//    });
//    var defaultStartDate = this.InputBox.data('selecteddate');
//    this.CSDatePicker.datepicker('setDate', defaultStartDate);
//    this.ActualSelectedDate = this.CSDatePicker.datepicker('getDate');
//    inputBox.on('keyup', function (e) {
//        if (e.keyCode == "13") {
//            element.trigger('blur');
//        }
//    }).on('change', function () {
//        var newStartDate = me.CSDatePicker.datepicker('getDate');
//        if (newStartDate != null /*&& (me.ActualSelectedDate == null || newStartDate.toString() != me.ActualSelectedDate.toString())*/) {
//            if (me.ActualSelectedDate != null) {
//                var diffYear = me.ActualSelectedDate.getFullYear() - newStartDate.getFullYear();
//                var diffMonth = me.ActualSelectedDate.getMonth() - newStartDate.getMonth();
//                var diffDay = me.ActualSelectedDate.getDate() - newStartDate.getDate();
//                me.OffsetYear = diffYear;
//                me.OffsetMonth = diffMonth;
//                me.OffsetDay = diffDay;
//            }
//            else {
//                me.OffsetYear = 0;
//                me.OffsetMonth = 0;
//                me.OffsetDay = 0;
//            }
//            me.ActualSelectedDate = newStartDate;
//            if (me.SelectionChange != null)
//                me.SelectionChange.call(me);
//            me.InputBox.trigger("CSChange", me);
//        }
//    });
//    return me;
//};

//# sourceMappingURL=cs.calendarpicker.js.map
